<template>
  <div>
    <div>
      <el-select v-model="mainThrust">
        <el-option
            v-for="item in unitOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
      <el-button @click="createECheckList(mainThrust)" style="margin-left: 30px">create</el-button>
    </div>
  </div>
</template>

<script>
import {Message} from "element-ui";
import description from "@/assets/json/description.json"

export default {
  name: "PreECheckList",
  props: {
    applicantId: {
      type: String,
      default: '',
      require: true
    },
    unitList: {
      type: Array,
      default: () => [],
      require: true
    }
  },
  data() {
    return {
      locked: false,
      mainThrust: "",
      unitOptions: [],
      cid: ""
    }
  },
  created() {
    this.generateUnitOptions(this.unitList)
  },
  methods: {
    async fetchECheckList() {
      let params = {
        username: this.applicantId
      }
      let fetchResponse = await this.$request.fetchECheckListByUsername(params)
      console.log(fetchResponse)
      if (fetchResponse) {
        // this.mainThrust = this.templateData.main_thrust
        this.cid = fetchResponse.data.cid
        if (fetchResponse.data.cid) {
          this.$emit('toECheckListEvent')
          this.toECheckList()
        }
      }
    },
    async createECheckList() {
      let params = {
        username: this.applicantId,
        mainThrust: this.mainThrust
      }
      if(this.mainThrust == ""){
        Message({
          message: description.checkListNoUnitWarning,
          type: "warning"
        })
        return
      }
      let createECheckListResponse = await this.$request.createECheckList(params)
      if (createECheckListResponse) {
        await this.fetchECheckList()
      }
    },
    generateUnitOptions(unitList) {
      console.log(unitList)
      let labelList = []
      for (let i = 0; i < unitList.length; i++) {
        // AIot = AI + IOT but not AIot
        if(unitList[i] === "Artificial Intelligence of Things"){
          if(!labelList.includes("Artificial Intelligence")){
            this.unitOptions.push({label: "Artificial Intelligence", value: "Artificial Intelligence"})
            labelList.push("Artificial Intelligence")
          }
          if(!labelList.includes("Internet of Things")){
            this.unitOptions.push({label: "Internet of Things", value: "Internet of Things"})
            labelList.push("Internet of Things")
          }
          if(!labelList.includes("Data Science and Analytics")){
            this.unitOptions.push({label: "Data Science and Analytics", value: "Data Science and Analytics"})
            labelList.push("Data Science and Analytics")
          }
        }
        else{
          if(!labelList.includes(unitList[i])){
            this.unitOptions.push({label: unitList[i], value: unitList[i]})
            labelList.push(unitList[i])
          }
        }
      }
    },
    toECheckList() {
      let routeData = this.$router.resolve({
        name: "eCheckList",
        query: {cid: this.cid},
      });
      window.open(routeData.href, "_blank");
    }
  }
}
</script>

<style lang="scss" scoped>
.input-class {
  width: 300px
}
</style>
